import {usePage} from "@inertiajs/inertia-react";

export default function useDefaultFilterConfig() {
    const { extendedMode, permissions, requesttypes, active_requesttype, partners, companies, } = usePage().props;

    return [
        {
            name: "requesttypes",
            columnClassName: "col-span-12 mt-3 mb-3",
        },
        {
            name: "search",
            columnClassName: "col-span-12 mb-3",
        },
        {
            name: "service",
            columnClassName: "col-span-6 md:col-span-2",
            condition: extendedMode,
        },
        {
            name: "status",
            columnClassName: "col-span-6 md:col-span-2",
        },
        {
            name: "partner",
            columnClassName: "col-span-6 md:col-span-2",
        },
        {
            name: "company",
            columnClassName: "col-span-6 md:col-span-2",
            condition: extendedMode,
        },
        {
            name: "dateOfService",
            columnClassName: "col-span-6 md:col-span-2",
            condition: !extendedMode,
        },
        {
            name: "dateFrom",
            columnClassName: "col-span-6 md:col-span-2",
            condition: extendedMode,
        },
        {
            name: "dateTo",
            columnClassName: "col-span-6 md:col-span-2",
            condition: extendedMode,
        },
        {
            name: "queue_export",
            columnClassName: "col-span-6 md:col-span-2",
            condition: extendedMode && permissions.includes("queue_export"),
        },
    ];
}
